export default "__VITE_ASSET__0a608e55__"